import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


// testimonials
const sliderTestimonials = new Swiper(".slider-testimonial", {
    effect: "fade",
    slidesPerView: 1,
	loop: true,
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
    },
    pagination: {
        el: ".slider-pagination",
        clickable: true
    },
});


// logos
if (window.innerWidth < 768) { 
    const sliderLogos = new Swiper(".slider-logos", {
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 2,
        loop: true,
        loopedSlides: 2,
        speed: 6000,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        breakpoints: {
            575: {
                slidesPerView: 3,
            },
        }
    });
};

// split content
const sliderSplit = new Swiper(".slider-split", {
    effect: "fade",
    slidesPerView: 1,
    loop: true,
    navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
    },
    pagination: {
        el: ".slider-pagination",
        clickable: true
    },
});

// general single slide slider with fade effect
const sliderFade = new Swiper(".slider-fade", {
    effect: "fade",
    slidesPerView: 1,
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
    },
    pagination: {
        el: ".slider-pagination",
        clickable: true
    },
});
(function($) {
	$('.image-with-text').each(function(){
		let prefix = $(this).attr('id');
		var sliderSplit = new Swiper(`#${prefix} .slider-split`, {
			effect: "fade",
			slidesPerView: 1,
			loop: true,
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				prevEl: `#${prefix} .slider-prev`,
				nextEl: `#${prefix} .slider-next`,
			},
			pagination: {
				el: `#${prefix} .slider-pagination`,
				clickable: true
			},
		});
	});
}(jQuery));